document.addEventListener('DOMContentLoaded', function() {
  // Select all mobile facets label elements
  const mobileFacetsLabels = document.querySelectorAll('.mobile-facets__label');

  console.log(mobileFacetsLabels);
  
  // Add click event listener to each label
  mobileFacetsLabels.forEach(label => {
    label.addEventListener('click', function(event) {
      // Find the checkbox inside this label
      console.log("clicked");
      const checkbox = this.querySelector('input[type="checkbox"]');
      console.log(checkbox);
      
      if (checkbox) {
        // Prevent default label behavior to control the toggle manually
        event.preventDefault();
        
        // Toggle the checkbox checked state
        checkbox.checked = !checkbox.checked;
        
        // Trigger change event on the checkbox for any other listeners
        const changeEvent = new Event('change', { bubbles: true });
        checkbox.dispatchEvent(changeEvent);
      } else {
        console.log("no checkbox");
      }
    });
  });
});